import {Button, ButtonGroup} from '@mui/material';
import update from 'immutability-helper';
import {isEmpty} from 'lodash';
import {useEffect, useState} from 'react';

import {DashboardPanelData} from '../../../interfaces/Dashboard';
import {DashboardPanelActionsSlot} from '../DashboardPanelActionsSlot';
import {
  getShaftClearanceAssetsReportData,
  ShaftClearanceAssetsReport,
  ShaftClearanceAssetsReportData,
} from './ShaftClearanceAssetsReport';
import {
  getShaftClearanceMinersReportData,
  ShaftClearanceMinersReport,
  ShaftClearanceMinersReportData,
} from './ShaftClearanceMinersReport';

interface Props {
  value?: DashboardPanelData;
  onUpdate?: (value: DashboardPanelData) => void;
}

interface ShaftClearanceReportData {
  reportType: 'assets' | 'employees';
  employees: ShaftClearanceMinersReportData;
  assets: ShaftClearanceAssetsReportData;
}

const getShaftClearanceReportData = (): ShaftClearanceReportData => ({
  reportType: 'employees',
  employees: getShaftClearanceMinersReportData(),
  assets: getShaftClearanceAssetsReportData(),
});

export const ShaftClearanceReport = (props: Props) => {
  const [config, setConfig] = useState(
    !isEmpty(props.value) ? props.value : getShaftClearanceReportData()
  );

  useEffect(() => {
    props.onUpdate?.({...config});
  }, [config]);

  return (
    <>
      <DashboardPanelActionsSlot>
        <ButtonGroup sx={{minWidth: 180}}>
          <Button
            size="small"
            variant={
              config.reportType === 'employees' ? 'contained' : 'outlined'
            }
            onClick={() => {
              setConfig(
                update(config, {
                  reportType: {
                    $set: 'employees',
                  },
                })
              );
            }}
          >
            Employees
          </Button>
          <Button
            size="small"
            variant={config.reportType === 'assets' ? 'contained' : 'outlined'}
            onClick={() => {
              setConfig(
                update(config, {
                  reportType: {
                    $set: 'assets',
                  },
                })
              );
            }}
          >
            Assets
          </Button>
        </ButtonGroup>
      </DashboardPanelActionsSlot>

      {config.reportType === 'assets' ? (
        <ShaftClearanceAssetsReport
          value={config.assets}
          onUpdate={(v) => {
            setConfig(
              update(config, {
                assets: {
                  $set: v,
                },
              })
            );
          }}
        />
      ) : config.reportType === 'employees' ? (
        <ShaftClearanceMinersReport
          value={config.employees}
          onUpdate={(v) => {
            setConfig(
              update(config, {
                employees: {
                  $set: v,
                },
              })
            );
          }}
        />
      ) : null}
    </>
  );
};
